(function (root) {
  function buildShopifyPath(path) {
    var routeRoot = root.Shopify && root.Shopify.routes && root.Shopify.routes.root ? root.Shopify.routes.root : '/';
    var normalizedRoot = routeRoot.endsWith('/') ? routeRoot : routeRoot + '/';
    var normalizedPath = String(path || '').replace(/^\//, '');

    return normalizedRoot + normalizedPath;
  }

  function stripTags(value) {
    return String(value || '').replace(/<[^>]*>/g, '');
  }

  function formatAmount(cents, precision, separator, delimiter) {
    var numericCents = Number(cents || 0);
    var sign = numericCents < 0 ? '-' : '';
    var amount = (Math.abs(numericCents) / 100).toFixed(precision);
    var parts = amount.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
    var decimals = parts[1] ? separator + parts[1] : '';

    return sign + dollars + decimals;
  }

  function formatMoney(cents) {
    if (root.Shopify && typeof root.Shopify.formatMoney === 'function') {
      return stripTags(root.Shopify.formatMoney(cents));
    }

    var format = root.theme && root.theme.moneyFormat ? root.theme.moneyFormat : '${{amount}}';
    var values = {
      amount: formatAmount(cents, 2, '.', ','),
      amount_no_decimals: formatAmount(cents, 0, '.', ','),
      amount_with_comma_separator: formatAmount(cents, 2, ',', '.'),
      amount_no_decimals_with_comma_separator: formatAmount(cents, 0, ',', '.')
    };

    return stripTags(format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_match, token) {
      return values[token] || values.amount;
    }));
  }

  function parseAjaxError(error) {
    if (!error) {
      return '';
    }

    if (typeof error === 'string') {
      return error;
    }

    return error.description || error.message || '';
  }

  function getProductHandle(url) {
    try {
      var productUrl = new URL(url || '', root.location && root.location.origin ? root.location.origin : 'https://example.com');
      var parts = productUrl.pathname.split('/').filter(Boolean).map(function (part) {
        return decodeURIComponent(part);
      });
      var productsIndex = parts.indexOf('products');

      return productsIndex >= 0 ? parts[productsIndex + 1] || '' : '';
    } catch (error) {
      return '';
    }
  }

  function normalizeOptions(product) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var options = Array.isArray(product.options) ? product.options : [];

    if (!options.length && Array.isArray(product.optionNames)) {
      options = product.optionNames;
    }

    if (options.length && typeof options[0] === 'object') {
      return options.map(function (option, index) {
        return {
          name: option.name || 'Option ' + (index + 1),
          position: option.position || index + 1,
          values: Array.isArray(option.values) ? option.values : []
        };
      });
    }

    return options.map(function (optionName, index) {
      var key = 'option' + (index + 1);
      var values = variants.reduce(function (list, variant) {
        var value = variant && variant[key];
        if (value && list.indexOf(value) === -1) {
          list.push(value);
        }

        return list;
      }, []);

      return {
        name: optionName || 'Option ' + (index + 1),
        position: index + 1,
        values: values
      };
    });
  }

  function getVariantOption(variant, index) {
    return variant ? variant['option' + (index + 1)] || '' : '';
  }

  function getVariantImage(variant, product) {
    if (variant && variant.featured_image) {
      if (typeof variant.featured_image === 'string') {
        return variant.featured_image;
      }

      if (variant.featured_image.src) {
        return variant.featured_image.src;
      }
    }

    return product.featured_image || product.image || '';
  }

  function normalizeImages(product) {
    var images = [];

    if (product.featured_image) {
      images.push(product.featured_image);
    }

    if (Array.isArray(product.images)) {
      product.images.forEach(function (image) {
        if (typeof image === 'string') {
          images.push(image);
        }
      });
    }

    if (Array.isArray(product.variants)) {
      product.variants.forEach(function (variant) {
        var image = getVariantImage(variant, {});
        if (image) {
          images.push(image);
        }
      });
    }

    return images.filter(function (image, index, list) {
      return image && list.indexOf(image) === index;
    });
  }

  function mergeVariantData(ajaxVariants, pageVariants) {
    var ajaxList = Array.isArray(ajaxVariants) ? ajaxVariants : [];
    var pageList = Array.isArray(pageVariants) ? pageVariants : [];
    var pageById = pageList.reduce(function (map, variant) {
      if (variant && variant.id) {
        map[String(variant.id)] = variant;
      }

      return map;
    }, {});

    if (!ajaxList.length) {
      return pageList;
    }

    return ajaxList.map(function (variant) {
      var pageVariant = pageById[String(variant.id)] || {};

      return Object.assign({}, variant, pageVariant, {
        featured_image: variant.featured_image || pageVariant.featured_image || null
      });
    });
  }

  function getQuantityRule(variant) {
    var rule = variant && typeof variant.quantity_rule === 'object' && variant.quantity_rule ? variant.quantity_rule : {};
    var min = Math.max(Number(rule.min) || 1, 1);
    var increment = Math.max(Number(rule.increment) || 1, 1);
    var max = Number(rule.max);

    return {
      min: min,
      increment: increment,
      max: Number.isFinite(max) && max > 0 ? max : null
    };
  }

  function alignQuantity(quantity, rule) {
    var nextQuantity = Math.max(Number(quantity) || rule.min, rule.min);
    var offset = nextQuantity - rule.min;
    var remainder = offset % rule.increment;

    if (remainder !== 0) {
      nextQuantity += rule.increment - remainder;
    }

    if (rule.max !== null) {
      nextQuantity = Math.min(nextQuantity, rule.max);
    }

    return nextQuantity;
  }

  function isProductPreviewDesktop() {
    return !root.matchMedia || root.matchMedia('(min-width: 750px)').matches;
  }

  function getRatingStarFill(rating, star) {
    var numericRating = Number(rating) || 0;
    var starOffset = Math.max((Number(star) || 1) - 1, 0);

    return Math.round(Math.max(0, Math.min(1, numericRating - starOffset)) * 100);
  }

  function alignQuantityToRule(quantity, rule, max) {
    var numericQuantity = Number(quantity);
    var requestedQuantity = Number.isFinite(numericQuantity) && numericQuantity > 0
      ? numericQuantity
      : rule.min;
    var upperBound = max === null ? requestedQuantity : max;
    var clampedQuantity = Math.max(rule.min, Math.min(requestedQuantity, upperBound));
    var steps = Math.floor((clampedQuantity - rule.min) / rule.increment);

    return rule.min + (steps * rule.increment);
  }

  function getVariantQuantityState(variant, requestedQuantity, cartQuantity) {
    var available = Boolean(variant && variant.available);
    var inventoryManagement = variant ? variant.inventory_management : null;
    var inventoryPolicy = variant ? variant.inventory_policy : null;
    var inventoryQuantity = Number(variant ? variant.inventory_quantity : 0);
    var quantityInCart = Math.max(Number(cartQuantity) || 0, 0);
    var tracksInventory = inventoryManagement === 'shopify' && inventoryPolicy !== 'continue';
    var rule = getQuantityRule(variant);

    if (!available) {
      return {
        value: 1,
        min: 1,
        max: 1,
        increment: 1,
        disabled: true
      };
    }

    if (tracksInventory) {
      var inventoryMax = Math.max(0, inventoryQuantity - quantityInCart);
      var rawMax = rule.max === null ? inventoryMax : Math.min(rule.max, inventoryMax);

      if (rawMax < rule.min) {
        return {
          value: 0,
          min: 0,
          max: 0,
          increment: rule.increment,
          disabled: true
        };
      }

      var max = alignQuantityToRule(rawMax, rule, rawMax);

      return {
        value: alignQuantityToRule(requestedQuantity, rule, max),
        min: rule.min,
        max: max,
        increment: rule.increment,
        disabled: false
      };
    }

    return {
      value: alignQuantityToRule(requestedQuantity, rule, rule.max),
      min: rule.min,
      max: rule.max === null ? null : alignQuantityToRule(rule.max, rule, rule.max),
      increment: rule.increment,
      disabled: false
    };
  }

  function getVariantStockCount(variant, cartQuantity) {
    if (!variant || !variant.available) {
      return 0;
    }

    if (variant.inventory_management !== 'shopify' || variant.inventory_policy === 'continue') {
      return 0;
    }

    return Math.max(Number(variant.inventory_quantity || 0) - Math.max(Number(cartQuantity) || 0, 0), 0);
  }

  function updateHeaderCartCount(cart, template) {
    if (!root.document || !cart || typeof cart.item_count === 'undefined') {
      return;
    }

    root.document.querySelectorAll('.site-header__cart-count').forEach(function (countBadge) {
      var count = String(cart.item_count);
      countBadge.textContent = count;
      countBadge.setAttribute('aria-label', String(template || '').replace('__count__', count));
    });
  }

  async function requestJson(path, options) {
    if (!root.fetch) {
      return {};
    }

    var response = await root.fetch(buildShopifyPath(path), options || {});
    var data = await response.json().catch(function () {
      return {};
    });

    if (!response.ok) {
      throw new Error(parseAjaxError(data) || response.statusText);
    }

    return data;
  }

  async function requestProductPageData(url) {
    if (!root.fetch || !root.DOMParser || !url) {
      return {};
    }

    var productUrl = new URL(url, root.location && root.location.origin ? root.location.origin : undefined);
    var response = await root.fetch(productUrl.href, {
      headers: {
        Accept: 'text/html'
      }
    });
    var html = await response.text();

    if (!response.ok) {
      throw new Error(response.statusText);
    }

    var doc = new root.DOMParser().parseFromString(html, 'text/html');
    var source = doc.querySelector('script[id^="ProductData-"]');

    if (!source) {
      return {};
    }

    return JSON.parse(source.textContent || '{}');
  }

  function registerAlpine() {
    if (!root.document || !root.Alpine) {
      return;
    }

    root.Alpine.data('productPreviewModal', function () {
      return {
        open: false,
        loadingProduct: false,
        adding: false,
        imageChanging: false,
        imageRequestKey: 0,
        stockAnimating: false,
        statusMessage: '',
        statusIsError: false,
        requestKey: 0,
        previousTrigger: null,
        selectedOptions: [],
        selectedVariant: null,
        activeImageIndex: 0,
        quantity: 1,
        cart: { items: [] },
        stockScaleMax: 20,
        stockAlertThreshold: 8,
        product: {
          title: '',
          price: '',
          url: '',
          image: '',
          imageAlt: '',
          vendor: '',
          rating: 0,
          ratingScaleMax: 5,
          ratingCount: 0,
          options: [],
          variants: [],
          images: []
        },
        destroy() {
          root.themeModalAccessibility?.deactivate(this.$root);
        },
        get labels() {
          var dataset = this.$root ? this.$root.dataset : {};

          return {
            add: dataset.labelAdd || '',
            adding: dataset.labelAdding || '',
            added: dataset.labelAdded || '',
            maxInCart: dataset.labelMaxInCart || '',
            soldOut: dataset.labelSoldOut || '',
            unavailable: dataset.labelUnavailable || '',
            error: dataset.labelError || '',
            stockLeft: dataset.labelStockLeft || '',
            stockCount: dataset.labelStockCount || '',
            saveAmount: dataset.labelSave || '',
            imageLabel: dataset.imageLabel || '',
            cartCountTemplate: dataset.cartCountTemplate || '',
            reviewRating: dataset.labelReviewRating || '',
            reviewCount: dataset.labelReviewCount || '',
            reviewCountOne: dataset.labelReviewCountOne || ''
          };
        },
        get ratingStars() {
          var scaleMax = Math.max(Number(this.product.ratingScaleMax) || 5, 1);

          return Array.from({ length: scaleMax }, function (_value, index) {
            return index + 1;
          });
        },
        get reviewRatingLabel() {
          return this.labels.reviewRating.replace('__rating__', String(this.product.rating || 0));
        },
        get reviewCountLabel() {
          var count = Number(this.product.ratingCount || 0);
          var template = count === 1 && this.labels.reviewCountOne
            ? this.labels.reviewCountOne
            : this.labels.reviewCount;

          return template.replace('__count__', String(count));
        },
        ratingStarFill(star) {
          return getRatingStarFill(this.product.rating, star);
        },
        get compareAtPrice() {
          if (!this.selectedVariant || !this.selectedVariant.compare_at_price) {
            return '';
          }

          if (Number(this.selectedVariant.compare_at_price) <= Number(this.selectedVariant.price)) {
            return '';
          }

          return formatMoney(this.selectedVariant.compare_at_price);
        },
        get saveAmountLabel() {
          if (!this.selectedVariant || !this.selectedVariant.compare_at_price) {
            return '';
          }

          var difference = Number(this.selectedVariant.compare_at_price) - Number(this.selectedVariant.price);

          if (difference <= 0) {
            return '';
          }

          return this.labels.saveAmount.replace('{amount}', formatMoney(difference));
        },
        get isAvailable() {
          return Boolean(this.selectedVariant && this.selectedVariant.available);
        },
        get hasVisibleOptions() {
          return this.product.options.some(function (option) {
            return !this.isDefaultOption(option);
          }.bind(this));
        },
        get isProductSoldOut() {
          return this.product.variants.length > 0 && !this.product.variants.some(function (variant) {
            return variant && variant.available;
          });
        },
        get quantityRule() {
          return getQuantityRule(this.selectedVariant);
        },
        get cartQuantity() {
          if (!root.cartInventory || !this.selectedVariant) {
            return 0;
          }

          return root.cartInventory.getCartVariantQuantity(this.cart, this.selectedVariant.id);
        },
        get quantityState() {
          return getVariantQuantityState(this.selectedVariant, this.quantity, this.cartQuantity);
        },
        get quantityMin() {
          return this.quantityState.min;
        },
        get quantityMax() {
          return this.quantityState.max;
        },
        get quantityIncrement() {
          return this.quantityState.increment;
        },
        get quantityDisabled() {
          return this.loadingProduct || this.quantityState.disabled;
        },
        get addDisabled() {
          return this.loadingProduct || this.adding || this.quantityState.disabled;
        },
        get stockCount() {
          return getVariantStockCount(this.selectedVariant, this.cartQuantity);
        },
        get showStockAlert() {
          return this.stockCount > 0 && this.stockCount < this.stockAlertThreshold;
        },
        get stockPercent() {
          if (!this.showStockAlert) {
            return 0;
          }

          return Math.min(Math.round((this.stockCount * 100) / this.stockScaleMax), 100);
        },
        get stockMessage() {
          if (!this.showStockAlert) {
            return '';
          }

          return this.labels.stockLeft.replace('{count}', this.stockCount);
        },
        get addButtonLabel() {
          if (this.adding) {
            return this.labels.adding;
          }

          if (!this.selectedVariant) {
            return this.labels.unavailable;
          }

          if (!this.selectedVariant.available) {
            return this.labels.soldOut;
          }

          if (this.quantityState.disabled) {
            return this.labels.maxInCart;
          }

          return this.product.price ? this.labels.add + ' ' + this.product.price : this.labels.add;
        },
        openPreview(event) {
          if (!isProductPreviewDesktop()) {
            return;
          }

          var detail = event.detail || {};
          var handle = getProductHandle(detail.url);
          this.requestKey += 1;
          this.previousTrigger = event.target && typeof event.target.focus === 'function' ? event.target : null;
          this.loadingProduct = Boolean(handle);
          this.adding = false;
          this.imageChanging = false;
          this.imageRequestKey += 1;
          this.stockAnimating = false;
          this.statusMessage = '';
          this.statusIsError = false;
          this.selectedOptions = [];
          this.selectedVariant = null;
          this.activeImageIndex = 0;
          this.quantity = 1;
          this.cart = { items: [] };
          this.stockScaleMax = 20;
          this.stockAlertThreshold = 8;
          this.product = {
            title: detail.title || '',
            price: detail.price || '',
            url: detail.url || '#',
            image: detail.image || '',
            imageAlt: detail.imageAlt || detail.title || '',
            vendor: detail.vendor || '',
            rating: Number(detail.rating) || 0,
            ratingScaleMax: Number(detail.ratingScaleMax) || 5,
            ratingCount: Number(detail.ratingCount) || 0,
            options: [],
            variants: [],
            images: detail.image ? [detail.image] : []
          };
          this.open = true;
          root.themeModalAccessibility?.activate(this.$root);
          document.documentElement.classList.add('product-preview-modal-open');
          this.loadProduct(detail.url, this.requestKey);
          this.$nextTick(function () {
            if (this.$refs.closeButton) {
              this.$refs.closeButton.focus();
            }
          }.bind(this));
        },
        closePreview() {
          if (!this.open) {
            return;
          }

          this.requestKey += 1;
          this.open = false;
          root.themeModalAccessibility?.deactivate(this.$root);
          document.documentElement.classList.remove('product-preview-modal-open');
          root.dispatchEvent?.(new root.CustomEvent('product-preview:closed'));
          this.$nextTick(function () {
            if (this.previousTrigger) {
              this.previousTrigger.focus();
            }
          }.bind(this));
        },
        trapFocus(event) {
          root.themeModalAccessibility?.trapFocus(event, event && event.currentTarget);
        },
        async loadProduct(url, requestKey) {
          var handle = getProductHandle(url);

          if (!handle) {
            return;
          }

          this.loadingProduct = true;

          try {
            var requests = await Promise.allSettled([
              requestJson('products/' + encodeURIComponent(handle) + '.js', {
                headers: {
                  Accept: 'application/json'
                }
              }),
              requestProductPageData(url),
              root.cartInventory ? root.cartInventory.fetchCart() : Promise.resolve({ items: [] })
            ]);
            var product = requests[0].status === 'fulfilled' ? requests[0].value : {};
            var pageData = requests[1].status === 'fulfilled' ? requests[1].value : {};
            var cart = requests[2].status === 'fulfilled' ? requests[2].value : { items: [] };

            if (!product.variants && !pageData.variants) {
              throw new Error(this.labels.unavailable);
            }

            if (requestKey !== this.requestKey) {
              return;
            }

            this.cart = cart;
            this.hydrateProduct(product, pageData);
          } catch (error) {
            if (requestKey === this.requestKey) {
              this.statusMessage = this.labels.unavailable;
              this.statusIsError = true;
            }
          } finally {
            if (requestKey === this.requestKey) {
              this.loadingProduct = false;
            }
          }
        },
        hydrateProduct(product, pageData) {
          var variants = mergeVariantData(product.variants, pageData.variants);
          var optionSource = {
            options: product.options || pageData.optionNames || [],
            optionNames: pageData.optionNames || [],
            variants: variants
          };
          var options = normalizeOptions(optionSource);
          var images = normalizeImages(product);
          var selectedVariant = variants.find(function (variant) {
            return variant && variant.available;
          }) || variants[0] || null;
          var nextImage = selectedVariant ? getVariantImage(selectedVariant, product) : product.featured_image || this.product.image;

          if (!images.length && this.product.image) {
            images.push(this.product.image);
          }

          if (nextImage && images.indexOf(nextImage) === -1) {
            images.unshift(nextImage);
          }

          this.stockScaleMax = Number(pageData.stockScaleMax || this.stockScaleMax || 20);
          this.stockAlertThreshold = Number(pageData.stockAlertThreshold || this.stockAlertThreshold || 8);
          this.product = {
            title: product.title || this.product.title,
            price: selectedVariant ? formatMoney(selectedVariant.price) : this.product.price,
            url: this.product.url,
            image: this.product.image || nextImage || images[0] || '',
            imageAlt: product.title || this.product.imageAlt,
            vendor: product.vendor || this.product.vendor,
            rating: Number(pageData.rating || this.product.rating) || 0,
            ratingScaleMax: Number(pageData.ratingScaleMax || this.product.ratingScaleMax) || 5,
            ratingCount: Number(pageData.ratingCount || this.product.ratingCount) || 0,
            options: options,
            variants: variants,
            images: images
          };
          this.selectedVariant = selectedVariant;
          this.selectedOptions = options.map(function (_option, index) {
            return getVariantOption(selectedVariant, index);
          });
          this.syncQuantity();
          this.setActiveImage(nextImage || this.product.image, product.title || this.product.imageAlt);
          this.restartStockAnimation();
        },
        imageLabel(index) {
          return this.labels.imageLabel.replace('__index__', index + 1);
        },
        setActiveImage(src, alt) {
          var imageIndex = this.product.images.indexOf(src);

          if (imageIndex >= 0) {
            this.activeImageIndex = imageIndex;
          }

          if (src) {
            this.transitionImage(src, alt);
          }
        },
        selectImage(index) {
          var image = this.product.images[index];

          if (!image) {
            return;
          }

          this.activeImageIndex = index;
          this.transitionImage(image, this.product.title || this.product.imageAlt);
        },
        expandImage(event) {
          var image = this.product.image;

          if (!image || !root.imageLightbox) {
            return;
          }

          root.imageLightbox.open({
            src: image,
            alt: this.product.imageAlt || this.product.title || '',
            trigger: event && event.currentTarget ? event.currentTarget : null
          });
        },
        scrollPreviewThumbs(direction) {
          var track = this.$refs.previewThumbs;
          var reduceMotion = root.matchMedia
            && root.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (!track) {
            return;
          }

          track.scrollBy({
            left: direction * 140,
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        },
        restartStockAnimation() {
          this.stockAnimating = false;
          this.$nextTick(function () {
            this.stockAnimating = this.showStockAlert;
          }.bind(this));
        },
        isDefaultOption(option) {
          return option && option.name === 'Title' && option.values.length === 1 && option.values[0] === 'Default Title';
        },
        isOptionValueAvailable(optionIndex, value) {
          return this.product.variants.some(function (variant) {
            if (!variant || !variant.available) {
              return false;
            }

            return this.selectedOptions.every(function (selectedValue, selectedIndex) {
              var comparedValue = selectedIndex === optionIndex ? value : selectedValue;

              return getVariantOption(variant, selectedIndex) === comparedValue;
            });
          }.bind(this));
        },
        selectOption(optionIndex, value) {
          this.selectedOptions[optionIndex] = value;
          this.statusMessage = '';
          this.statusIsError = false;
          this.syncVariant();
        },
        syncVariant() {
          var nextVariant = this.product.variants.find(function (variant) {
            return this.selectedOptions.every(function (value, index) {
              return getVariantOption(variant, index) === value;
            });
          }.bind(this)) || null;

          this.selectedVariant = nextVariant;

          if (!nextVariant) {
            return;
          }

          this.product.price = formatMoney(nextVariant.price);
          this.syncQuantity();
          this.setActiveImage(getVariantImage(nextVariant, this.product), this.product.title);
          this.restartStockAnimation();
        },
        syncQuantity() {
          this.quantity = this.quantityState.value;
          this.restartStockAnimation();
        },
        syncCartAvailability(cart) {
          if (!cart) {
            return;
          }

          this.cart = cart;
          this.syncQuantity();
        },
        incrementQuantity() {
          if (this.quantityDisabled) {
            return;
          }

          var nextQuantity = this.quantity + this.quantityIncrement;
          this.quantity = this.quantityMax === null ? nextQuantity : Math.min(nextQuantity, this.quantityMax);
          this.syncQuantity();
        },
        decrementQuantity() {
          if (this.quantityDisabled) {
            return;
          }

          this.quantity = Math.max(this.quantity - this.quantityIncrement, this.quantityMin);
          this.syncQuantity();
        },
        transitionImage(src, alt) {
          if (!src || src === this.product.image) {
            return;
          }

          var imageKey = this.imageRequestKey + 1;
          this.imageRequestKey = imageKey;
          this.imageChanging = true;

          var minimumDelay = new Promise(function (resolve) {
            root.setTimeout(resolve, 140);
          });
          var imageReady = new Promise(function (resolve) {
            if (!root.Image) {
              resolve();
              return;
            }

            var preload = new root.Image();
            preload.onload = resolve;
            preload.onerror = resolve;
            preload.src = src;
          });

          Promise.all([minimumDelay, imageReady]).then(function () {
            if (imageKey !== this.imageRequestKey) {
              return;
            }

            this.product.image = src;
            this.product.imageAlt = alt || this.product.imageAlt;
            root.requestAnimationFrame(function () {
              if (imageKey === this.imageRequestKey) {
                this.imageChanging = false;
              }
            }.bind(this));
          }.bind(this));
        },
        closePreviewOnMobile() {
          if (this.open && !isProductPreviewDesktop()) {
            this.closePreview();
          }
        },
        async addToCart() {
          if (this.addDisabled) {
            return;
          }

          this.adding = true;
          this.statusMessage = '';
          this.statusIsError = false;

          try {
            var absoluteQuantityState = getVariantQuantityState(this.selectedVariant, this.quantity, 0);
            var result = await root.cartInventory.addVariant({
              id: Number(this.selectedVariant.id),
              quantity: Math.max(Number(this.quantityState.value) || 1, 1),
              maxQuantity: absoluteQuantityState.max,
              minimum: absoluteQuantityState.min,
              increment: absoluteQuantityState.increment
            });
            var cart = result.cart;
            this.syncCartAvailability(cart);
            updateHeaderCartCount(cart, this.labels.cartCountTemplate);
            this.statusMessage = result.message
              || (result.addedItems.length ? this.labels.added : this.labels.maxInCart);
            this.statusIsError = Boolean(result.message);
            root.document.dispatchEvent(new root.CustomEvent('cart:updated', {
              detail: { cart: cart, message: result.message || '' }
            }));
          } catch (error) {
            this.statusMessage = parseAjaxError(error) || this.labels.error;
            this.statusIsError = true;
            if (error && error.cart) {
              this.syncCartAvailability(error.cart);
              updateHeaderCartCount(error.cart, this.labels.cartCountTemplate);
            }
            root.document.dispatchEvent(new root.CustomEvent('cart:error', {
              detail: {
                cart: error && error.cart ? error.cart : null,
                message: this.statusMessage
              }
            }));
          } finally {
            this.adding = false;
          }
        }
      };
    });
  }

  if (root.document) {
    root.document.addEventListener('alpine:init', registerAlpine);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      buildShopifyPath: buildShopifyPath,
      formatMoney: formatMoney,
      getRatingStarFill: getRatingStarFill,
      getVariantQuantityState: getVariantQuantityState,
      getProductHandle: getProductHandle,
      isProductPreviewDesktop: isProductPreviewDesktop,
      normalizeOptions: normalizeOptions
    };
  }
})(typeof window !== 'undefined' ? window : globalThis);
